(() => {
  if (customElements.get('opd-accessory-quick-add')) return;

  class OpdAccessoryQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.select = this.querySelector('[data-opd-accessory-select]');
      this.link = this.querySelector('[data-opd-accessory-link]');
      this.price = this.querySelector('[data-opd-accessory-price]');
      this.media = this.querySelector('[data-opd-accessory-media]');
      this.defaultMedia = this.querySelector('[data-opd-accessory-default-media]');
      this.variantMedia = this.querySelector('[data-opd-accessory-variant-media]');
      this.button = this.querySelector('[data-opd-accessory-add]');
      if (!this.select || !this.link || !this.price || !this.media || !this.defaultMedia || !this.variantMedia || !this.button) return;
      this.onChange = () => this.update();
      this.select.addEventListener('change', this.onChange);
      window.addEventListener('pageshow', this.onChange);
      this.update();
    }

    disconnectedCallback() {
      this.connected = false;
      this.select?.removeEventListener('change', this.onChange);
      window.removeEventListener('pageshow', this.onChange);
    }

    update() {
      const option = this.select.selectedOptions[0];
      const valid = Boolean(option?.value && !option.disabled && option.dataset.url);
      this.button.disabled = !valid;
      this.price.hidden = false;
      const imageUrl = valid && !this.select.hidden ? option.dataset.image : '';
      this.defaultMedia.hidden = Boolean(imageUrl);
      this.variantMedia.hidden = !imageUrl;
      if (!valid) {
        this.link.setAttribute('href', this.link.dataset.productUrl || '#');
        this.price.textContent = this.price.dataset.defaultPrice || ''; 
        return;
      }
      this.link.setAttribute('href', option.dataset.url);
      this.price.textContent = option.dataset.price;
      if (!imageUrl) return;
      let image = this.variantMedia.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.loading = 'lazy';
        image.width = 420;
        image.height = 420;
        this.variantMedia.append(image);
      }
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      if (image.getAttribute('src') !== imageUrl) image.setAttribute('src', imageUrl);
      image.alt = option.dataset.imageAlt || '';
    }
  }

  customElements.define('opd-accessory-quick-add', OpdAccessoryQuickAdd);
})();


